import { useEffect } from 'react';
import { SalesRolePopup } from 'src/pages/ConfigurationPage/PersonaTab/PersonaForm/DynamicFields/RoleDescriptionField/SalesRoleField/SalesRolePopup/SalesRolePopup';
import type { PersonaFieldProps } from 'src/pages/ConfigurationPage/PersonaTab/PersonaForm/DynamicFields/personaFieldProps';
import type {
  PersonaInputData,
  SalesRoleCta,
  SalesRoleIcp,
} from 'src/pages/ConfigurationPage/utils/getPersonaFormValues';

export const SalesRoleField = ({
  data,
  setValue,
  readonly = false,
  roleClickValue,
  watch,
}: Pick<PersonaFieldProps<'pf_cta'>, 'setValue' | 'watch' | 'readonly' | 'compact'> & {
  data: Pick<PersonaInputData, 'pf_cta' | 'pf_icp'>;
  roleClickValue?: string;
}) => {
  useEffect(() => {
    if (data.pf_cta) {
      setValue('pf_cta', data.pf_cta);
    }
    if (data.pf_icp) {
      setValue('pf_icp', data.pf_icp);
    }
  }, []);

  const addSalesRole = (submitData: { pf_icp: SalesRoleIcp[]; pf_cta: SalesRoleCta[] }) => {
    setValue('pf_icp', submitData.pf_icp);
    setValue('pf_cta', submitData.pf_cta);
  };

  return (
    <div className={'flex flex-col w-full gap-2.5'}>
      {!readonly && (
        <div>
          <SalesRolePopup
            data={data}
            watch={watch}
            addSalesRole={addSalesRole}
            roleClickValue={roleClickValue}
          />
        </div>
      )}
    </div>
  );
};
